<template>
  <div class="project-list" :class="{'project-back': goBack}">

    <div class="next-project" @click="next()">
      <div class="main">next</div>
      <div class="sub">project</div>
    </div>
    <div class="prev-project" v-if="currentIndex>0" @click="prev()">
      <div class="main">prev</div>
      <div class="sub">project</div>
    </div>
    <div class="prev-project" v-if="currentIndex===0" @click="reset()">
      <div class="main">to</div>
      <div class="sub">HOMEPAGE</div>
    </div>

    <transition-group name="slide-fade">
      <project
        v-for="(project, index) in projects"
        v-if="index === currentIndex"
        :key="project.id"
        :project="project"
        :index="currentIndex+1"
      />
    </transition-group>

  </div>
</template>

<script>
  import Project from "./Project";
  import {projects} from "../services/projects";

  export default {
    name: "ProjectList",
    components: {Project},

    data() {
      return {
        currentIndex: 0,
        goBack: false,
        projects,
      }
    },

    methods: {
      next() {
        this.goBack = false;
        this.currentIndex = parseInt(this.currentIndex) + 1;
      },
      prev() {
        this.goBack = true;
        this.currentIndex = parseInt(this.currentIndex) - 1;
      },
      reset() {
        this.$emit('reset');
      }
    }
  }
</script>

<style lang="scss">
  @import "src/components/ProjectList";
</style>
